import { isBefore, isAfter } from 'date-fns'
import { formatDate, NotEmpty } from './date.js'

const storiesOrderArr = ['recently-added', 'oldest-first', 'random', 'chronological']

export function getFormattedStoriesOrder(storiesOrder){
  if(!storiesOrder) return 'recently-added'
  if(!storiesOrderArr.includes(storiesOrder)) return 'recently-added'

  return storiesOrder
}

const sortByMostRecentlyAdded = (storyOne, storyTwo) => {
  const keyA = new Date(storyOne.createdAt),
    keyB = new Date(storyTwo.createdAt)
  // Compare the 2 dates
  if(keyA < keyB) return 1
  if(keyA > keyB) return -1
  return 0
}

const sortByOldestAddedFirst = (storyOne, storyTwo) => {
  const keyA = new Date(storyOne.createdAt),
    keyB = new Date(storyTwo.createdAt)

  if(keyA > keyB) return 1
  if(keyA < keyB) return -1
  return 0
}

// Timeline, Chronologically used interchangeably
// Uses the custom dates entered by user
const sortByTimeline = (storyOne, storyTwo) => {
  const dateOneString = formatDate({
    day: storyOne.startDay,
    month: storyOne.startMonth,
    year: storyOne.startYear
  })

  const dateTwoString = formatDate({
    day: storyTwo.startDay,
    month: storyTwo.startMonth,
    year: storyTwo.startYear
  })

  const dateOne = new Date(dateOneString)
  const dateTwo = new Date(dateTwoString)

  if(isBefore(dateOne, dateTwo)) return -1
  if(isAfter(dateOne, dateTwo)) return 1
  return 0
}

const randomShuffle = function(stories) {
  for(let i = stories.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1))
    var temp = stories[i]
    stories[i] = stories[j]
    stories[j] = temp
  }
  return stories
}

export function sortStories(sortOrder, stories) {

  sortOrder = getFormattedStoriesOrder(sortOrder)

  switch(sortOrder) {
    case 'recently-added':
      stories = stories.sort(sortByMostRecentlyAdded)
      break
    case 'oldest-first':
      stories = stories.sort(sortByOldestAddedFirst)
      break
    case 'chronological':
      stories = stories.filter(s => NotEmpty(s.startYear)).sort(sortByTimeline)
      break
    case 'random':
      stories = randomShuffle(stories)
      break
    default:
      console.error('no valid sort order found')
      stories = []
  }

  return stories
}

